<template>
  <div class="page">
    <main-menu-bar/>
    <div class="page-inner">
      <current-motion/>
    </div>
  </div>
</template>

<script>
import CurrentMotion from '../motions/CurrentMotion.vue'
import MainMenuBar from '../nav/MainMenuBar.vue'

export default {
  name: 'CurrentMotionPage',
  components: {
    CurrentMotion,
    MainMenuBar
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/CurrentMotionPage.vue